export const ForceDelete = {
    Enable: 1,
    Disable: 0,
};
